import { configuration } from '../apis';
// @ts-ignore
import polyfills from 'event-source-polyfill';

const EventSource = polyfills.EventSourcePolyfill;

const createSecureEventSource = async (url: string, onMessage: (ev: MessageEvent) => void): Promise<EventSource> => {
  const eventSource = new EventSource(configuration.basePath + url, {
    headers: {
      Authorization: configuration.accessToken && (await configuration.accessToken()),
      Accept: ['text/event-stream', 'application/json'],
    },
  });
  eventSource.onmessage = onMessage;
  return eventSource;
};

export { createSecureEventSource };
